import allfeatLogo from "../assets/branding/allfeat-logo.svg";

export const About = () => (
  <div className="text-sm bg-neutral-100 text-black opacity-70 p-4 rounded-3xl">
    <img
      src={allfeatLogo}
      alt="Allfeat"
      className="w-40 mb-3"
    />
    Allfeat Metadata Portal — unsigned QR codes for the latest runtime metadata
    of Allfeat and Melodie.
  </div>
);
